// extracted by mini-css-extract-plugin
module.exports = {"SrBanner":"SrBanner--SrBanner--1Bmtv","icon":"SrBanner--icon--o8IgW","highlightYellowFadeIn":"SrBanner--highlightYellowFadeIn--1xMnB"};